"use client";

import { QueryProvider } from "src/providers/QueryProvider";
import { OrderProvider } from "src/contexts";
import { FilesProvider } from "src/contexts";
import { CartDrawerProvider } from "src/contexts";
import { ChatWidgetPlacement } from "src/components/chat-widget-placement";
import { ColorModeContextProvider } from "src/contexts";
import { CouponProvider } from "src/contexts";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import GlobalStyles from "@mui/material/GlobalStyles";
import { PricingIntegrationProvider } from "src/components/pricing-integration-provider";

export function Providers({
  children,
  initialMode,
}: {
  children: React.ReactNode;
  initialMode?: string;
}) {
  return (
    <QueryProvider>
      <ColorModeContextProvider initialMode={initialMode}>
        <CssBaseline />
        <GlobalStyles styles={{ html: { WebkitFontSmoothing: "auto" } }} />
        {/* Page-bg owner: a theme-aware wrapper that fills the viewport,
            so the visual bg flips on toggle via React re-render rather than
            depending on CssBaseline's body{} rule (which accumulates stale
            entries when the theme switches at runtime). */}
        <Box
          sx={{
            bgcolor: "background.default",
            color: "text.primary",
            minHeight: "100vh",
          }}
        >
          <OrderProvider>
            <CouponProvider>
              <FilesProvider>
                <PricingIntegrationProvider>
                  <CartDrawerProvider>
                    {children}
                    <ChatWidgetPlacement />
                  </CartDrawerProvider>
                </PricingIntegrationProvider>
              </FilesProvider>
            </CouponProvider>
          </OrderProvider>
        </Box>
      </ColorModeContextProvider>
    </QueryProvider>
  );
}
